import get from "lodash/get";

/**
 * A utility that returns a sort comparator that compares on the
 * given property.
 *
 * @param {String} propPath - the dotted object property path.
 * @param {('asc'|'desc')} direction - the sort direction.
 * @param {Object} a - First object to compare
 * @param {Object} b - Second object to compare.
 *
 * @return {number} - Returns an ordinal representing the rank of the sort.
 */
export function sortByProp(
  propPath: string,
  direction: "asc" | "desc",
  a: unknown,
  b: unknown,
): number {
  const multiplier = direction === "asc" ? 1 : -1;
  const aVal = get(a, propPath);
  const bVal = get(b, propPath);

  if (aVal < bVal) {
    return multiplier * -1;
  }

  if (aVal > bVal) {
    return multiplier;
  }

  return 0;
}

export const sortByDisplayNameAsc = sortByProp.bind(
  null,
  "display_name",
  "asc",
);
export const sortByKeyAsc = sortByProp.bind(null, "k", "asc");
export const sortByLabelAsc = sortByProp.bind(null, "label", "asc");
export const sortByNameAsc = sortByProp.bind(null, "name", "asc");
export const sortByValueAsc = sortByProp.bind(null, "value", "asc");

export const sortNumericAsc = (a: number, b: number) => a - b;
